module.exports = __webpack_public_path__ + "img/Wp_2046.71f8ec63.png";